import { render } from "./VehicleLogisticsDetail.vue?vue&type=template&id=3cacd041&scoped=true&bindings={}"
import script from "./VehicleLogisticsDetail.vue?vue&type=script&lang=ts"
export * from "./VehicleLogisticsDetail.vue?vue&type=script&lang=ts"

import "./VehicleLogisticsDetail.vue?vue&type=style&index=0&id=3cacd041&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cacd041"

export default script